// extracted by mini-css-extract-plugin
export default {"commonAreaList":"commonArea_list_commonAreaList__yPfFc","Mui-focused":"commonArea_list_Mui-focused__wpNC3","label":"commonArea_list_label__YWy7h"};